import React from 'react';
import { ReactComponent as EHLogoSvg } from '../assets/img/logos/ellipsis-health.svg';
import classnames from 'classnames';

type Props = {
    children?: React.ReactNode;
    className?: string;
};

const EHLogo: React.FC<Props> = ({ children = <EHLogoSvg />, className }) => {
    return (
        <div className={classnames("eh-logo", className)}>
            {children}
        </div>
    );
};

export default EHLogo;
